import React from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import BannerImage from '../components/img/radiology-lab-banner.png';
import '../styles/pages.css';

function RadiologyLaboratory() {
    return (
        <div>
            {/* Navbar */}
            <Navbar />
            {/* Navbar Ending */}

            {/* Page Content starts here */}
            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Radiology & Laboratory</p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            Experience advanced diagnostic care with Caritas Matha 
                            <br/> 
                            Hospital's cutting-edge Radiology and Laboratory Services.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                            Experience advanced diagnostic care with Caritas Matha Hospital's cutting-edge Radiology and Laboratory Services.
                        </p>
                    </div>

                    <div className="page-box">
                        <div className="box-content">
                            <p>Caritas Matha Hospital's Radiology and Laboratory Services offer state-of-the-art diagnostic capabilities with advanced imaging technologies and comprehensive laboratory testing. Our dedicated team of radiologists and lab technicians ensures accurate results and timely reports, supporting effective patient care.</p>
                        </div>
                        <div className="box-image">
                            <img src={BannerImage} alt="Clinical Nutrition" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="page-content-section">
                <div className='page-content'>
                    <p className='page-content-heading'>
                        Empowering Health Journeys with
                        <br />
                        Advanced Radiology & Laboratory Services
                        
                    </p>
                    <br />
                    <div className='page-details'>
                        <p>At Caritas Matha Hospital, our Radiology & Laboratory services are the cornerstone of our commitment to delivering timely, cost-effective, and top-quality diagnostic care. We prioritize patient well-being by providing a safe and secure environment for all diagnostic procedures. Our state-of-the-art Radiology & Laboratory facilities, coupled with the expertise of our staff, ensure accurate diagnoses and efficient treatment planning while maintaining patient safety and comfort as our top priority. At Caritas, we take pride in setting the standard for excellence in diagnostic healthcare.</p>
                        <br />
                        
                        <h5>Services Offered by the Radiology & Laboratory : </h5>
                        <br />

                        <h6>24/7 Laboratory Services</h6>
                        <br />
                        <ul>    
                            <li><p>Our comprehensive laboratory operates round-the-clock, offering a wide range of diagnostic tests and services to support timely diagnosis and treatment across all medical specialties.</p></li>
                        </ul>
                        <br />

                        <h6>Radiology and Imaging : </h6>
                        <br />
                        <ul>
                            <li><p>Equipped with advanced technology, including 24/7 availability of MRI Scan, CT Scan, Ultrasound Scan, and X-Ray services, ensuring precise imaging for accurate diagnoses.</p></li>
                        </ul>
                        <br />

                        <h6>Interventional Radiology : </h6>
                        <br />
                        <ul>
                            <li><p>Specialized procedures such as angiograms and 2D Echo are performed by experienced radiologists to diagnose and treat conditions using minimally invasive techniques.</p></li>
                        </ul>
                        <br />

                        <h6>Nuclear Medicine and PET-CT : </h6>
                        <br />
                        <ul>
                            <li><p>Cutting-edge imaging techniques like PET-CT scans provide detailed insights into metabolic and physiological changes, aiding in the diagnosis and treatment of various diseases.</p></li>
                        </ul>
                        <br />

                        <h6>Specialized Diagnostic Procedures : </h6>
                        <br />
                        <ul>
                            <li><p>Including Mammography for breast health, EEG/EMG for neurological assessments, Sleep Lab for sleep disorders, Holter Monitoring and Treadmill Tests for cardiac evaluations, and Spirometry for pulmonary function testing.</p></li>
                        </ul>
                        <br />

                        <h6>Endoscopy Services : </h6>
                        <br />
                        <ul>
                            <li><p>Conducted by skilled professionals to examine internal organs and tissues, facilitating accurate diagnosis and treatment planning.</p></li>
                        </ul>
                        <br />

                        <p>At Caritas Matha Hospital, our commitment to excellence in Radiology & Laboratory services ensures that every patient receives the highest standard of diagnostic care, supported by advanced technology and compassionate healthcare professionals.</p>
                        <br />
                    </div>
                </div>

                <div className="more-services">
                    <p className="more-services-heading">More Services</p>
                    <div className='more-services-links'>
                        <a href="/blood-bank"><p> Blood Bank</p></a>
                        <a href="/clinical-nutrition"><p> Clinical Nutrition</p></a>
                        <a href="/insurance-partners"><p> Insurance Partners</p></a>
                        <a href="/caritas-mortuary-services"><p> Caritas Mortuary Services</p></a>
                        <a href="/pastoral-care"><p> Pastoral Care</p></a>
                        <a href="/caritas-home-care"><p> Caritas Home Care</p></a>
                        <a href="https://www.caritashospital.org/health-checkup-packages"><p> Health Checkup Packages</p></a>
                        <a href="/video-consultation"><p> Video Consultation</p></a>
                    </div>
                </div>
            </section>

            {/* Page content ends here */}

            {/* Footer */}
            <Footer />
            {/* Footer Ending */}
        </div>
    );
}

export default RadiologyLaboratory;